var React = require('react');

function Css3Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h69.09l-6.283 71.877L34.47 80 6.29 71.873 0 0zm56.227 14.71l-43.363-.01.7 8.74 33.313.007-.84 9.053H24.193l.79 8.577H45.32L44.116 52.82l-9.574 2.68-9.725-2.7-.619-7.033h-8.587l.954 12.85 17.98 5.676 17.678-5.1 4.004-44.48v-.003z"}));
}

Css3Inline.defaultProps = {"viewBox":"0 0 70 80"};

module.exports = Css3Inline;

Css3Inline.default = Css3Inline;
